import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { quotePropertyName } from '@cli-utils/text.js'
import { assertSupportedSchemaFieldType } from '@core-engine/schema/type-mappers/validation/assert-supported-schema-field-type.js'

export function buildNestedListType(fields: SchemaField[]): string {
  return fields
    .flatMap((f) => {
      assertSupportedSchemaFieldType(f)

      let type: string
      if (f.type === 'list' && f.fields && f.fields.length > 0) {
        const innerType = buildNestedListType(f.fields)
        type = `Array<{ ${innerType} }>`
      } else if ((f.type === 'group' || f.type === 'section') && f.fields && f.fields.length > 0) {
        type = `{ ${buildNestedListType(f.fields)} }`
      } else if (f.type === 'list') {
        type = 'string[]'
      } else if (f.type === 'number' || f.type === 'decimal') {
        type = 'number'
      } else if (f.type === 'boolean') {
        type = 'boolean'
      } else {
        type = 'string'
      }
      const result = [`${quotePropertyName(f.name)}?: ${type}`]
      if (f.hasIcon) {
        result.push(`${quotePropertyName(`${f.name}Icon`)}?: string`)
      }
      return result
    })
    .join('; ')
}
